var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { space, fontSize, borderRadius, zIndex, compose, } from 'styled-system';
import propTypes from '@styled-system/prop-types';
import PropTypes from 'prop-types';
import { Text } from '../Text';
import { applyVariations, getPaletteColor, borders, deprecatedColorValue, borderRadiusAttrs, applySizes, } from '../utils';
const sizes = {
    sm: css `
    padding: 6px 12px 7px 12px;
  `,
    md: css `
    padding: 10px 12px 11px 12px;
  `,
    lg: css `
    padding: 14px 12px 14px 12px;
  `,
    xl: css `
    padding: 18px 12px 19px 12px;
  `,
};
const StyledInput = styled.input.attrs(borderRadiusAttrs) `
  position: relative;
  appearance: none;
  display: block;
  width: 100%;
  font-family: inherit;
  color: ${getPaletteColor('text.base')};
  background-color: transparent;
  border-width: 1px;
  border-style: solid;
  margin: 0;

  ::placeholder {
    color: ${getPaletteColor('text.light')};
  }

  ::-ms-clear {
    display: none;
  }

  &:disabled,
  &:read-only {
    background-color: ${getPaletteColor('background.light')};
    color: ${getPaletteColor('text.light')};
    cursor: not-allowed;
  }

  ${({ theme }) => applySizes(sizes, undefined, theme.mediaQueries)};
  ${applyVariations('Input')}
  ${borders}

  ${(props) => compose(space, fontSize, borderRadius, zIndex)(props)}
`;
const INPUT_ERROR_TEXT = 'InputHelperText';
const inputPropTypes = Object.assign(Object.assign({ id: PropTypes.string.isRequired, color: deprecatedColorValue(), 
    /**
     * Display text below the input and set error color on input
     */
    size: PropTypes.oneOf(Object.keys(sizes)), helperText: PropTypes.node }, propTypes.space), propTypes.fontSize);
export const Input = React.forwardRef((props, ref) => {
    const { helperText, color } = props, restProps = __rest(props, ["helperText", "color"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledInput, Object.assign({}, restProps, { color: color, ref: ref })),
        helperText &&
            React.cloneElement(helperText, {
                color: helperText.props.color || color,
            })));
});
const HelperText = styled(Text).attrs(() => ({
    mt: 2,
    fontSize: 1,
})) ``;
Input.HelperText = (props) => React.createElement(HelperText, Object.assign({}, props), props.children);
Input.HelperText.displayName = INPUT_ERROR_TEXT;
Input.displayName = 'Input';
Input.isField = true;
Input.defaultProps = {
    fontSize: [2, null, 1],
    borderRadius: 'lg',
    size: 'lg',
};
Input.propTypes = inputPropTypes;
export default Input;
//# sourceMappingURL=Input.js.map